import { Box } from "@mui/material";
import { useTabContext } from "../../store";

export const TabPanel = ({ children, value, sx = {} }) => {
  const { value: contextValue } = useTabContext();
  const isActive = contextValue === value;

  return (
    <Box role="tabpanel" hidden={!isActive} sx={{ py: 3, ...sx }}>
      {isActive && children}
    </Box>
  );
};
